module.exports = __webpack_public_path__ + "img/scene-50.b3d2fa44.png";